import * as React from "react";
import styled from "styled-components";

import thumbnailUrl from "../utils/getThumbnailUrl";
import stringToColor from "../utils/stringToColor";
import { chooseBestContrast } from "../utils/colorContrast";

interface AvatarProps {
  user?: { uuid: string; name: string; pictureUrl: string | null };
  size?: number;
  round?: boolean;
}

interface ImageProps {
  size: number;
  round: boolean;
}

const Avatar: React.FC<AvatarProps> = ({ user, size = 40, round = true }) => {
  const [error, setError] = React.useState(false);

  const didError = user && error;

  const handleError = React.useCallback(() => {
    if (user) {
      setError(true);
    }
  }, [user]);

  React.useEffect(() => {
    setError(false);
  }, [user]);

  if (user && user.pictureUrl && !didError) {
    const imgUrl = user.pictureUrl.includes("gravatar")
      ? user.pictureUrl
      : thumbnailUrl(user.pictureUrl);

    return (
      <ProfileImg
        src={imgUrl}
        size={size}
        round={round}
        onError={handleError}
      />
    );
  }

  return (
    <UserInitials
      size={size}
      round={round}
      style={{
        backgroundColor: user ? stringToColor(`${user.name}`) : "#999",
        color: user
          ? chooseBestContrast(stringToColor(`${user.name}`), ["#fff", "#000"])
          : "#fff",
      }}
    >
      {user
        ? `${user.name
            .split(" ")
            .slice(0, 2)
            .map((x) => x.charAt(0))
            .join("")}`
        : null}
    </UserInitials>
  );
};

const ProfileImg = styled.img`
  width: ${({ size }: ImageProps) => size}px;
  height: ${({ size }: ImageProps) => size}px;
  object-fit: cover;
  border-radius: ${({ round }: ImageProps) => (round ? "50%" : 0)};
`;

const UserInitials = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ size }: ImageProps) => size / 2}px;
  width: ${({ size }: ImageProps) => size}px;
  height: ${({ size }: ImageProps) => size}px;
  border-radius: ${({ round }: ImageProps) => (round ? "50%" : 0)};
`;

export default Avatar;
